import React from 'react';
import ResetPW from "../../layout/pages/login/ResetPW";
import {Col, Modal, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";

const PwResetModal = (props) => {

  return (
      <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
      >
        <Modal.Header closeButton closeVariant={"white"}>
          <Modal.Title id="contained-modal-title-vcenter">
            비밀번호 변경
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ResetPW
              {...props}
          />
        </Modal.Body>
        <Modal.Footer>
          {/*<Row className={"justify-content-center text-center"}>*/}
          <Col md={2}>
            <Button
                type={"button"}
                variant="primary"
                className={"btn btn-primary save-btn w-100"}
                // onClick={onSubmit}
            >
              변경</Button>
          </Col>
          <Col md={2}>
            <Button
                type={"button"}
                variant="secondary"
                className={"btn-secondary cancel-btn w-100"}
                onClick={props.onHide}
            >
              취소
            </Button>
          </Col>
          {/*</Row>*/}
        </Modal.Footer>
      </Modal>
  );
};

export default PwResetModal;
